import { HttpContextToken } from '@angular/common/http';

// ErrorIntercept rejoue une fois toute requête en échec. C'est sans risque sur un GET, mais pas sur un
// appel qui écrit : une erreur survenue après que le serveur a validé son travail produirait un second
// enregistrement. Les requêtes concernées posent ce jeton pour sortir du réessai, sans que
// l'intercepteur ait à connaître leur URL.
export const NO_RETRY = new HttpContextToken<boolean>(() => false);
